var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5c4.5 0 6 4 6 4s1.5-4 6-4 8.5 6 6 12c-1.773 4.256-7.068 7.757-9.997 9.433-.615.352-.922.528-1.384.625a3.52 3.52 0 0 1-1.238 0c-.462-.097-.77-.273-1.384-.625C9.068 23.257 3.773 19.756 2 15.5c-2.5-6 1.5-12 6-12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike28);
export default __webpack_public_path__ + "static/media/like_28.7fd3c4e4.svg";
export { ForwardRef as ReactComponent };